import { Config } from './config'

export interface State {
  /**
   * @see {@link Config}
   */
  readonly config: Config
  /**
   * Used to present transitions
   */
  readonly configHasRecentlyChanged: boolean
  readonly hovered: boolean
  readonly pinned: boolean
  readonly logoHovered: boolean
  readonly logoMenuOpen: boolean
  readonly expandedTenantIds: ReadonlySet<string>
  readonly expandedAppIds: ReadonlySet<string>
  readonly expandedUtilitiesAppIds: ReadonlySet<string>
  readonly slideoutExpanded: boolean
  /**
   * Tracks the dynamic width of the navbar to ensure proper positioning of
   * attached overlays.
   */
  readonly width: number | undefined
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    config: Config.DEFAULT,
    configHasRecentlyChanged: false,
    expandedAppIds: new Set(),
    expandedTenantIds: new Set(),
    expandedUtilitiesAppIds: new Set(),
    hovered: false,
    logoHovered: false,
    logoMenuOpen: false,
    pinned: false,
    slideoutExpanded: false,
    width: undefined,
  }
}
